import { first } from 'lodash';
import * as ActionTypes from '../constants/ActionTypes';
import { push } from 'react-router-redux';
import { receiveEntities } from './entities';
import { setMessage } from './systemMessage';
import Vendor from '../records/vendor';
import Image from '../records/image';

import { 
  forwardGeolocate, 
  getCustomerDetails, 
  updateCustomerVendor 
} from '../actions/customer';

import { uploadImagesToCloudinary } from '../actions/cloudinary';
import { completeClaim } from '../actions/merchant';
import { api } from '../store';

import { Events } from 'ui-utilities';

export const saveHours = (placeId, plan) => {
  if (!placeId) return Promise.reject('Invalid place');

  return (dispatch, getState) => {
    return Promise.all(plan.get('editing_hours')
      .filter(h => h.first().get('open'))
      .map((h, k, i) => Promise.all(h
        .filter(j => j.get('open') && !getState()
          .entities
          .get('hours')
          .find(hour => hour.day === j.get('day') && hour.open === j.get('open') && hour.close === j.get('close')))
        .map(l => l.$create(placeId)))).toArray())
  }
}

export const processPayment = (stripeToken, vendorId) => {
  return (dispatch, getState) => {
    const { plan } = getState();

    if (plan.get('plan') === 'free' || plan.get('plan') === 'farm') {
      return Promise.resolve('No charge');
    }

    return api().post({
      resource: 'subscriptions'
    }, api().payload('subscriptions', {
      stripe_token: stripeToken.id,
      vendor_id: vendorId
    }));
  }
}

export const savePlan = stripeToken => {
  return (dispatch, getState) => {
    let action = '$create';
    let v = new Vendor();
    let value = '0.00';

    const { auth, entities, merchant, plan } = getState();

    if (plan.get('plan') === 'basic') value = '85.00';
    if (plan.get('plan') === 'enhanced-full') value = '295.00';

    dispatch({
      type: ActionTypes.SAVING_PLAN,
      value: true
    });

    if (merchant.get('claiming')) {
      action = '$put';
      v = entities
        .get('vendors')
        .get(entities
          .get('merchant')
          .first()
          .get('vendor_id'));
    }

    v = v.withMutations(map => map
      .set('user_id', auth.get('user').get('user_id'))
      .set('name', plan.get('businessPlace').name)
      .set('plan', plan.get('plan'))
      .set('hidden', true)
      .set('claimed', true)
    );

    const geoLocatedPlace = getState().entities.get('places').first();
    const businessPlace = plan.get('businessPlace').withMutations(map => map
      .set('latitude', geoLocatedPlace.latitude)
      .set('longitude', geoLocatedPlace.longitude)
    );

    const invite = entities.get('supplyInvites').first();

    return v[action]()
      // allow images to upload independetly from promise chain
      .then(res => {
        Promise.all([dispatch(uploadImagesToCloudinary())
          .then(images => Promise.all(images.map((i, j) => new Image({ 
            url: i, 
            label: j < 1 ? 'profile' : '' // use the first image as a profile pic
          }).$create(res.data.id)))),
          dispatch(uploadImagesToCloudinary(plan.get('logo')))
            .then(images => Promise.all(images.map(i => new Image({
              url: i, 
              label: 'logo'
            }).$create(res.data.id))))]);

        return res;
      })
      .then(res => Promise.all([
        businessPlace[action](res.data.id)
          .then(place => plan.get('businessPhone')[action](place.data.id))
          .then(contact => plan.get('businessEmail')[action](contact.data && contact.data.attributes.owner_id))
          .then(contact => plan.get('url').text !== '' ? plan.get('url')[action]( contact.data && contact.data.attributes.owner_id) : contact),
        //.then(contact => dispatch(saveHours(contact.data.attributes.owner_id, plan))),
        plan.get('contactPlace').$create(res.data.id)
          .then(place => plan.get('contactPhone').$create(place.data.id)),
        v.$putTags(res.data.id),
        merchant.get('claiming') && dispatch(completeClaim(res.data.id)),
        invite && invite.withMutations(map => map
          .set('invited_vendor_id', res.data.id)
          .set('accepted', true)
        ).$put(),
        dispatch(updateCustomerVendor(res, false)),
        dispatch(processPayment(stripeToken, res.data.id))
      ]))
      .then(res => dispatch(getCustomerDetails()))
      // add instagram
      .then(res => dispatch({
        type: ActionTypes.SAVING_PLAN,
        value: false
      }))
      .then(res => Events
        .provide('facebook', true)
        .log(
          'Registration-' + plan.get('plan'), {
            value: value,
            currency: 'USD'
          }))
      .then(res => dispatch(push('/dashboard')))
      .catch(err => console.log(err));
  }
}

export const upgradePlan = (stripeToken, plan) => {
  return (dispatch, getState) => {
    const vendorId = getState()
      .customer
      .get('account')
      .get('activeVendorId');

    const vendor = getState()
      .entities
      .get('vendors')
      .get(vendorId)
      .set('plan', first(plan.validations.val));

    return Promise.all([
      vendor.$put(),
      dispatch(processPayment(stripeToken, vendor.id))
    ])
    .then(res => dispatch(setMessage('success', 'Plan successfully upgraded!')))
    .then(res => setTimeout(() => dispatch(setMessage('none', '')), 5000))
    .then(res => Events
      .provide('kissmetrics', true)
      .log(
        'record',
        'Subscriber Plan Upgrade', {
          'Merchant Name': vendor.name,
          'Merchant Tier': first(plan.validations.plan)
        }));
  }
}

export const getTags = () => {
  return dispatch => {
    return api().get({
      resource: 'tags'
    })
    .then(res => dispatch(receiveEntities(res.data, 'tags')));
  }
}

export const setBusinessLocation = location => {
  return dispatch => {
    return dispatch({
      type: ActionTypes.SET_BUSINESS_LOCATION,
      payload: location
    });
  }
};

export const setPlan = plan => {
  return dispatch => {
    Events
      .provide('kissmetrics', true)
      .log(
        'record',
        'Subscriber Onboarding 3: Select Plan', {
          'Merchant Tier - Select Plan': plan
        }
      );

    return dispatch({
      type: ActionTypes.SET_PLAN,
      plan: plan
    });
  }
};

export const setStep = step => {
  return (dispatch, getState) => {
    let promise = Promise.resolve(null);
    if (step === 3) promise = dispatch(forwardGeolocate(getState().plan.get('businessPlace')));

    return promise
      .then(res => dispatch({
        type: ActionTypes.SET_STEP,
        step: step
      }))
      .catch(err => console.log(err));
  }
};

export const setAccountInfo = (accountInfo) => ({
  type: ActionTypes.SET_ACCOUNT_INFO,
  payload: accountInfo
});

export const replaceBusinessInfo = vendorId => {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.REPLACE_BUSINESS_INFO,
      payload: getState().entities.get('vendors').get(vendorId)
    });
  }
};

export const setBusinessInfo = (businessInfo) => ({
  type: ActionTypes.SET_BUSINESS_INFO,
  payload: businessInfo
});

export const setLogo = (logo) => ({
  type: ActionTypes.SET_LOGO,
  logo: logo
});

export const setPhotos = photos => {
  return dispatch => {
    dispatch({
      type: ActionTypes.SET_PHOTOS,
      photos: photos
    });
  }
}

export const setInstagramPhotos = photos => {
  return dispatch => {
    dispatch({
      type: ActionTypes.SET_INSTAGRAM_PHOTOS,
      instagram_photos: photos
    });
  }
}

export const setDeleteImages = images => {
  return dispatch => {
    dispatch({
      type: ActionTypes.SET_DELETE_IMAGES,
      delete_images: images,
    })
  }
}

export const setDetails = (details) => ({
  type: ActionTypes.SET_DETAILS,
  payload: details
});

export const updateHours = hours => ({
  type: ActionTypes.UPDATE_HOURS,
  payload: hours
});

export const updateHoursEditState = (day, type, key, time) => {
  return dispatch => {
    return dispatch({
      type: ActionTypes.UPDATE_HOURS_EDIT_STATE,
      payload: {
        day: day,
        type: type,
        key: key,
        time: time
      }
    });
  }
};

export const resetPlan = () => ({
  type: ActionTypes.RESET_PLAN
});

export const resetHoursEditState = (day) => {
  return dispatch => {
    return dispatch({
      type: ActionTypes.RESET_HOURS_EDIT_STATE,
      payload: {
        day: day ? day.toLowerCase() : null
      }
    })
  }
}

export const resetTags = () => ({
  type: ActionTypes.RESET_TAGS
});

export const updateTags = tags => ({
  type: ActionTypes.UPDATE_TAGS,
  payload: tags
});

export const updateTagsEditState = (tags) => ({
  type: ActionTypes.UPDATE_TAGS_EDIT_STATE,
  tags: tags
});



// WEBPACK FOOTER //
// ./src/actions/plan.js